import { alpha, Stack, styled, SxProps, Theme } from '@ltvco/refresh-lib/theme';

export const inputStyles = (theme: Theme) =>
  ({
    overflow: 'hidden',
    '& .MuiInputBase-input': {
      minHeight: '48px',
      maxHeight: '200px',
      boxSizing: 'border-box',
      padding: '12px 48px 12px 12px',
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
      overflowY: 'auto',
      width: '100%',
      resize: 'none',
      lineHeight: '24px',
      margin: 0,
      fontSize: '14px',
    },
    '& .MuiInputBase-root': {
      minHeight: '48px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      borderRadius: '32px',
      border: `1px solid ${alpha(theme.palette.barChart.contrastText, 0.12)}`,
      padding: 0,
      position: 'relative',
      width: '100%',
      boxSizing: 'border-box',
      overflow: 'hidden',
      '& .MuiInputBase-input': {
        height: 'auto',
        minHeight: '24px',
        padding: '12px 48px 12px 12px',
      },
    },
    '& .MuiInputBase-inputMultiline': {
      padding: 0,
    },
    '.MuiOutlinedInput-notchedOutline': {
      display: 'none',
    },
  } as const);

export const containerStyles: SxProps<Theme> = {
  position: 'relative',
  width: '100%',
  boxSizing: 'border-box',
  padding: '16px',
  display: 'flex',
  alignItems: 'center',
} as const;

export const sendButtonStyles: SxProps<Theme> = {
  position: 'absolute',
  right: '24px',
  top: '50%',
  transform: 'translateY(-50%)',
  color: 'primary.main',
  zIndex: 1,
  '&:hover': {
    backgroundColor: 'transparent',
  },
} as const;

export const chipStyles: SxProps<Theme> = {
  position: 'absolute',
  bottom: '100%',
  right: '100%',
  backgroundColor: (theme) => theme.palette.background.paper,
  color: 'text.primary',
  borderRadius: '24px',
  padding: '8px 16px',
  fontSize: '14px',
  fontWeight: 500,
  zIndex: 2,
  boxShadow: (theme) =>
    `0 4px 12px ${alpha(theme.palette.barChart.contrastText, 0.08)}`,
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  whiteSpace: 'nowrap',
  maxWidth: '300px',
  marginBottom: '4px',
  marginRight: '4px',
} as const;

export const closeButtonStyles: SxProps<Theme> = {
  width: '24px',
  height: '24px',
  minWidth: '24px',
  backgroundColor: (theme) => theme.palette.background.default,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  border: 'none',
  padding: 0,
  '&:hover': {
    backgroundColor: (theme) => theme.palette.button.light,
  },
} as const;

export const SearchAssistantMobileContainer = styled(Stack)<{
  isChatbotOpen: boolean;
}>(({ isChatbotOpen }) => ({
  position: 'fixed',
  height: '100%',
  bottom: 0,
  right: 0,
  zIndex: 2000,
  width: '100%',
  transition: 'all 0.3s ease-in-out',
  transform: isChatbotOpen ? 'translateY(0)' : 'translateY(100%)',
}));
